import { ActionTree } from 'vuex'
import { RootState } from '@/store/RootState'
import { Resource, UserLocation } from '@/config/interfaces'

export const actions: ActionTree<RootState, RootState> = {
  toggleViewState ({ commit }, payload: string) {
    commit('toggleViewState', payload)
  },
  commitViewContent ({ commit }, payload: Record<string, unknown> | string) {
    commit('setViewContent', payload)
  },
  toggleLeftViewState ({ commit }, payload: boolean) {
    commit('setLeftViewState', payload)
  },
  commitLeftViewContent ({ commit }, payload: Record<string, unknown> | string) {
    commit('setLeftViewContent', payload)
  },
  changeCardBackground ({ commit }, payload: string) {
    commit('setCardBackground', payload)
  },
  changeLeftViewTitle ({ commit }, payload: string) {
    commit('setLeftViewTitle', payload)
  },
  postParams ({ commit }, payload: URLSearchParams | null) {
    commit('setPostParams', payload)
  },
  commitUserLocation ({ commit }, payload: UserLocation) {
    commit('setUserLocation', payload)
  },
  changeIdentifier ({ commit }, payload: Resource) {
    commit('setIdentifier', payload)
  },
  commitToken ({ commit }, token: string) {
    commit('setToken', token)
  },
  commitLastLoggedInUser ({ commit }, lastLoggedInUser: string) {
    commit('setLastLoggedInUser', lastLoggedInUser)
  },
  commitHasPin ({ commit }, hasPin: boolean) {
    commit('setHasPin', hasPin)
  },
  changeCurrentNavigationKey ({ commit }, payload: string) {
    commit('setCurrentNavigationKey', payload)
  },
  commitIdentifiers ({ commit }, identifiers: Array<Resource>) {
    commit('setIdentifiers', identifiers)
  },
  commitIdentifiersBundles ({ commit }, identifiers: Array<Array<Resource>>) {
    commit('setIdentifiersBundles', identifiers)
  },
  commitAllowResend ({ commit }, allow: boolean) {
    commit('setAllowResend', allow)
  },
  commitRefreshLeftView ({ commit }, refresh: boolean) {
    commit('setRefreshLeftView', refresh)
  },
  commitBillValues ({ commit }, payload: Array<string>) {
    commit('setBillValues', payload)
  },
  commitJumpOnCloseURI ({ commit }, payload: string) {
    commit('setJumpOnCloseURI', payload)
  },
  commitAudio ({ commit }, payload: string) {
    commit('setAudio', payload)
  }
}
